import { DatabaseService } from './DatabaseService';
import { FirebaseService } from './FirebaseService';

// Validate Firebase config
const hasFirebaseConfig = !!(
  import.meta.env.VITE_FIREBASE_API_KEY &&
  import.meta.env.VITE_FIREBASE_PROJECT_ID
);

export const createDatabaseService = (): DatabaseService => {
  if (!hasFirebaseConfig) {
    throw new Error(
      'Firebase configuration is missing. Please check your .env file and ensure all required Firebase variables are set.'
    );
  }

  return new FirebaseService();
};

export const dbService = createDatabaseService();

export type { DatabaseService };
